import apiClient from './apiClient';
import { SIGN_UP } from '../constants/UriConstants';
import { SignUpRequest } from '../types/SignUpInterface';

const signUp = (signUpCredentials: SignUpRequest): Promise<string> =>
  apiClient.post(SIGN_UP, signUpCredentials).then((response) => response.data);

export default signUp;
